import React from 'react';
import '../styles/contactus.css';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { HiEnvelope } from "react-icons/hi2";
import robot from '../assets/contactus.png'


const ContactUs = () => {
    return (
        <div className="contactus">
            <div className="row">
                <div className="col-12 col-md-8">
                    <h1>Get in Touch with <span style={{ color: '#FFD52B' }}>CO6 Robotics </span> Let's Build the Future Together!</h1>
                    <p>
                        We’re here to answer your questions, discuss your automation needs, 
                        and explore innovative solutions.
                    </p>
                    <div className="form-container mt-4">
                <form>
                    <div className="row">
                        {/* Name and Last Name */}
                        <div className="col-12 col-md-6">
                            <input type="text" placeholder="Name" className="form-input" />
                        </div>
                        <div className="col-12 col-md-6 second-input">
                            <input type="text" placeholder="Last Name" className="form-input" />
                        </div>

                        {/* Email and Phone Number */}
                        <div className="col-12 col-md-6 mt-3">
                            <input type="email" placeholder="Email address" className="form-input" />
                        </div>
                        <div className="col-12 col-md-6 mt-3">
                            <input type="text" placeholder="Phone number" className="form-input" />
                        </div>

                        {/* Message Field */}
                        <div className="col-12 mt-3">
                            <textarea placeholder="Message" className="form-textarea"></textarea>
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div className="text-left mt-4">
                        <button type="submit" className="form-button">
                            Send Message
                        </button>
                    </div>
                </form>
            </div>
            <div className='row mt-5'>
            <div className="col-12 col-md-6">
            <h5>Get in Touch</h5>
            <div style={{display:'flex' ,alignItems:'center'}}>
            <div className="icons">
                        <a href="#" aria-label="Facebook"><HiEnvelope size='1.2rem' /></a>
            </div>
            <p style={{marginBottom:'0px' ,marginLeft:'5px'}}>info@co6.ae</p>
            </div>
            </div>
            <div className="col-12 col-md-6">
            <div className='contactus-social' style={{display:'flex' , justifyContent:'end',alignItems:'center'}}>
            <div className="social-links">
                      <h4>FOLLOW US:</h4>
                      <div className="icons">
                        <a href="#" aria-label="Facebook"><FaFacebookF /></a>
                        <a href="#" aria-label="Instagram"><FaInstagram /></a>
                        <a href="#" aria-label="LinkedIn"><FaLinkedinIn /></a>
                        <a href="#" aria-label="Twitter"><FaTwitter /></a>
                      </div>
                    </div>
            </div>

            </div>
            </div>
                </div>
                <div className="col-12 col-md-4" >
                    <img className='contactus-img' src={robot} width="500rem" style={{objectFit:'cover'}}></img>
                </div>
            </div>

            
            
        </div>
    );
};

export default ContactUs;
